<template>
  <div style="background-color: #fff;">
    <Filter />
    <Table />
    <Drawer />
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, provide, onMounted } from 'vue'
import Filter from './components/filter.vue'
import Table from './components/table.vue'
import Drawer from './components/drawer'
import { common_querySiteInfo_get } from './../../server/modules/3426'
import {
  abLayer_page_post,
  abLayer_save_post,
  abLayer_remove_get,
  abLayer_allocate_post
} from './../../server/modules/12707'
import { message } from 'ant-design-vue'
export default defineComponent({
  name: '实验层',
  components: {
    Filter,
    Table,
    Drawer
  },
  setup() {
    const state = reactive({
      drawerTitle: '创建实验层',
      flowRatePercent: 0,
      flowRateDataSource: [],
      flowRateVisible: false,
      saveFlowRate: async () => {
        let emptyPercent = []
        for (let i = 0; i < state.flowRateDataSource.length; i++) {
          let item = state.flowRateDataSource[i]
          if (!item.weight) {
            emptyPercent.push(item)
          }
        }
        if (state.flowRateDataSource.length > 0 && emptyPercent.length > 0) {
          message.error('实验分配流量比例不能为空')
          return
        }
        const { success, retInfo } = await abLayer_allocate_post(
          state.flowRateDataSource
        )
        if (success) {
          state.flowRateVisible = false
          state.pageInfo.pageNum = 1
          state.getTableList()
        } else {
          message.error(retInfo)
        }
      },
      changeWeight: () => {
        state.flowRatePercent = 0
        state.flowRateDataSource.forEach(i => {
          state.flowRatePercent += i.weight
        })
        if (state.flowRatePercent > 100) {
          message.error('流量占用总和不能大于100%')
        }
      },
      allocationFlow: record => {
        state.flowRatePercent = 0
        state.flowRateVisible = true
        if (!record.abLayerAllocationDTOS) {
          record.abLayerAllocationDTOS = []
        }
        state.flowRateDataSource = JSON.parse(
          JSON.stringify(record.abLayerAllocationDTOS)
        )
        state.flowRateDataSource.forEach(i => {
          state.flowRatePercent += i.weight
        })
      },
      closeflowRateDrawer: () => {
        state.flowRateVisible = false
      },
      createFormRef: null,
      createVisible: false,
      closeCreateDrawer: () => {
        state.createFormRef.resetFields()
        state.createVisible = false
      },
      saveCreateDrawer: () => {
        state.createFormRef.validate().then(async () => {
          const { success, retInfo } = await abLayer_save_post({
            ...state.createForm,
            ...state.elementParams
          })
          if (success) {
            state.createVisible = false
            state.pageInfo.pageNum = 1
            state.getTableList()
          } else {
            message.error(retInfo)
          }
        })
      },
      createForm: {
        name: '',
        subject: 1,
        description: ''
      },
      createFormRules: {
        name: [
          { required: true, message: '请输入实验层名称', trigger: 'blur' },
          {
            validator: (rule, value) => {
              const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/
              if (!regex.test(value)) {
                return Promise.reject(
                  new Error('请输入包含中文、大小写字母、数字、下划线的值')
                )
              } else {
                return Promise.resolve()
              }
            },
            trigger: 'blur'
          }
        ],
        subject: [
          {
            required: true,
            message: '请选择分层主体',
            trigger: 'change',
            type: 'number'
          }
        ]
      },
      createFormDisabled: false,
      deleteLayer: async record => {
        const { success, retInfo } = await abLayer_remove_get({
          layerId: record.id
        })
        if (success) {
          state.pageInfo.pageNum = 1
          state.getTableList()
        } else {
          message.error(retInfo)
        }
      },
      editLayer: record => {
        state.drawerTitle = '编辑实验层'
        state.createFormDisabled = true
        state.createForm = JSON.parse(JSON.stringify(record))
        state.createVisible = true
      },
      createNewLayer: () => {
        state.drawerTitle = '创建实验层'
        state.createForm = {
          name: '',
          subject: 1,
          description: ''
        }
        state.createFormDisabled = false
        state.createVisible = true
      },
      elementParams: {
        brandId: 1,
        channelId: 1,
        siteId: 1,
        terminalId: 1
      },
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 1
      },
      brands: [],
      channels: [],
      sites: [],
      dataSource: [],
      getElementsInfo: async () => {
        const { data } = await common_querySiteInfo_get()
        state.brands = data[1]
        state.channels = data[2]
        state.sites = data[3]
      },
      onPageChange: (page, pageSize) => {
        if (pageSize !== state.pageInfo.pageSize) {
          state.pageInfo.pageNum = 1
        } else {
          state.pageInfo.pageNum = page
        }
        state.pageInfo.pageSize = pageSize
        state.getTableList()
      },
      getTableList: async () => {
        const { success, data } = await abLayer_page_post({
          ...state.elementParams,
          ...state.pageInfo
        })
        if (success) {
          state.dataSource = data.list
          state.pageInfo.total = data.total
          state.pageInfo.pages = data.pages
        }
      }
    })

    provide('initState', state)
    onMounted(() => {
      state.getElementsInfo()
      state.getTableList()
    })
    return {
      ...toRefs(state)
    }
  }
})
</script>
